import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  LinearProgress
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';

interface BulkQRMenuSendDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  processing: boolean;
  progress: number;
  results: {
    success: number;
    failed: number;
    total: number;
    alreadyOpen?: number; // ✅ Zaten açık olan ürün sayısı
    alreadyOpenNames?: string[]; // ✅ Zaten açık olan ürün isimleri
  };
  currentItem: string;
}

export const BulkQRMenuSendDialog: React.FC<BulkQRMenuSendDialogProps> = ({
  open,
  onClose,
  onConfirm,
  processing,
  progress,
  results,
  currentItem,
}) => {
  return (
    <Dialog
      open={open}
      onClose={!processing ? onClose : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Toplu QR Menü Açma
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Seçili {results.total} adet ürün QR Menü'de açılacaktır.
        </DialogContentText>
        
        {processing && (
          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              İşleniyor: {currentItem}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" value={progress} color="success" />
              </Box>
              <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">
                  {`${progress}%`}
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', border: '1px solid #ddd', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                İşlem Durumu:
              </Typography>
              <Typography variant="body2" color="success.main">
                ✅ Başarılı: {results.success}
              </Typography>
              <Typography variant="body2" color="error.main">
                ❌ Başarısız: {results.failed}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                📊 Toplam: {results.total}
              </Typography>
            </Box>
          </Box>
        )}
        
        {!processing && (
          <>
          <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', border: '1px solid #ddd', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              İşlem Detayları:
            </Typography>
            <Typography variant="body2">
                • Açılacak ürün sayısı: {results.total}
              </Typography>
              {results.alreadyOpen !== undefined && results.alreadyOpen > 0 && (
                <Typography variant="body2" color="warning.main" sx={{ mt: 1 }}>
                  ⚠️ Zaten açık olan ürün sayısı: {results.alreadyOpen}
            </Typography>
              )}
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Sadece kapalı olan ürünler QR Menü'de açılacaktır.
              </Typography>
            </Box>
            
            {/* Zaten açık olan ürünleri göster */}
            {results.alreadyOpen !== undefined && results.alreadyOpen > 0 && results.alreadyOpenNames && (
              <Box sx={{ mt: 2, p: 2, bgcolor: '#fff3e0', border: '1px solid #ff9800', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom color="warning.main">
                  🔓 Zaten QR Menü'de Açık Olan Ürünler:
                </Typography>
                <Box sx={{ maxHeight: '150px', overflowY: 'auto', mt: 1 }}>
                  {results.alreadyOpenNames.map((name, index) => (
                    <Typography key={index} variant="body2" sx={{ ml: 2, fontSize: '0.85rem' }}>
                      • {name}
                    </Typography>
                  ))}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  Bu ürünler işleme dahil edilmeyecektir.
            </Typography>
          </Box>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          color="primary"
          disabled={processing}
        >
          {processing ? 'İşlem Devam Ediyor...' : 'İptal'}
        </Button>
        {!processing && (
          <Button 
            onClick={onConfirm} 
            color="success" 
            variant="contained"
            startIcon={<StorefrontIcon />}
          >
            QR Menü'de Aç
          </Button>
        )}
        {processing && progress === 100 && (
          <Button 
            onClick={onClose} 
            color="primary" 
            variant="contained"
          >
            Tamam
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

